import React, { useState, useEffect } from "react";
import Menu from '../../assets/icons/Menu.svg';
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import logo from '../../assets/images/pam-web-logo.svg';
import HomeIcon from '../../assets/icons/Home1.svg';
import AddressIcon from '../../assets/icons/Address.svg';
import SettingIcon from '../../assets/icons/More.svg';
import FavouriteIcon from '../../assets/icons/Love.svg';
import Dashboard from '../../assets/icons/Dashboard.svg';
import ManageUser from '../../assets/icons/ManageUser1.svg';
import Search from '../../assets/icons/search.svg';
import DeleteUser from '../../assets/icons/Delete1.svg';
import Feedback from '../../assets/icons/Feedback1.svg';
import Report from '../../assets/icons/Report.svg';
import AddIcon from '../../assets/icons/plusss.svg';
import Referrals from '../../assets/icons/referrals.svg';
import ManageAddressIcon from '../../assets/icons/manageaddress.svg';
import { jwtDecode } from "jwt-decode";
import ReactGA from "react-ga4";
import { useLocalization } from "../Context/MultiLanguageContext";
import apiUser from '../../assets/images/apiUser.svg';

interface MenuItem {
  name: string;
  link: string;
  icon: string;
}

interface TokenPayload {
  RoleId: number;
}

const SidebarLayout: React.FC = () => {
  const [roleId, setRoleId] = useState<number | null>(null);
  const [open, setOpen] = useState<boolean>(() => window.innerWidth >= 768);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLocalization();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decodedToken = jwtDecode<TokenPayload>(token);
        setRoleId(Number(decodedToken.RoleId));
      } catch (error) {
        // console.error('Error decoding token:', error);
      }
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setOpen(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  useEffect(() => {
  }, [roleId]);


  useEffect(() => {
    const handleResize = () => {
      setOpen(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const menus: MenuItem[] = [
    { name: t("homepage"), link: "/home", icon: HomeIcon },
    { name: t("addressList"), link: "/addresslist", icon: AddressIcon },
    { name: t("addNewAddress"), link: "/add-new-address", icon: AddIcon },
    { name: t("favourites"), link: "/favourites", icon: FavouriteIcon },
    { name: t("more"), link: "/more", icon: SettingIcon },

    ...(roleId === 1
      ? [

        { name: "-- ADMIN --", link: "#admin-separator", icon: "" },

        { name: t("dashboard"), link: "/dashboard", icon: Dashboard },
        { name: t("manageUser"), link: "/manageuser", icon: ManageUser },
        { name: t("manageApiUser"), link: "/manage-api-user", icon: apiUser },
        { name: t("manageAddress"), link: "/manageaddress", icon: ManageAddressIcon },
        { name: t("searchHistory"), link: "/search-summary", icon: Search },
        { name: t("deleteRequest"), link: "/view-delete-request", icon: DeleteUser },
        { name: t("feedback"), link: "/viewfeedback", icon: Feedback },
        { name: t("userReferrals"), link: "/referrals", icon: Referrals },
        { name: t("problems"), link: "/ViewreportIssue", icon: Report },
      ]
      : []),
  ].filter((menu: MenuItem) => {
    if (roleId === 3 && (menu.link === "/addresslist" || menu.link === "/add-new-address")) {
      return false;
    }
    return true;
  });

  const getActiveMenu = (): string => {
    const path = location.pathname;

    if (path.includes("/addresslist")) {
      return "/addresslist";
    }
    if (path.includes("/address-details")) {
      return "/addresslist";
    }
    if (path.includes("/edit-address/")) {
      return "/addresslist";
    }
    if (path.includes("/search-address-details")) {
      return "/home";
    }
    if (path.includes("/address")) {
      return "/home";
    }
    if (path.includes("/favourite-address-details")) {
      return "/favourites";
    }
    if (path.includes("/add-new-address")) {
      return "/add-new-address";
    }
    if (path.includes("/viewfeedback") || path.includes("/feedback-details")) {
      return "/viewfeedback";
    }

    if (path.includes("/view-report") || path.includes("/report-issue-details")) {
      return "/ViewreportIssue";
    }
    if (path.includes("/manageuser") || path.includes("/user-details")) {
      return "/manageuser";
    }

    if (path.includes("/manageaddress") || path.includes("/edit-address-admin")) {
      return "/manageaddress";
    }

    if (path.includes("/about") || path.includes("/feedback") || path.includes("/report-issue") || path.includes("/profile") || path.includes("/update-user-profile")) {
      return "/more";
    }
    if (path.includes("/referrals") || path.includes("/referral-user")) {
      return "/referrals";
    }
    if (path.includes("/view-delete-request") || path.includes("/delete-request-details")) {
      return "/view-delete-request";
    }
    if (path.includes("/pamcode-details")) {
      return "/search-summary";
    }

    const firstSegment = "/" + (path.split("/")[1] || "home");
    return firstSegment;
  };

  const activeMenu = getActiveMenu();

  const handleMenuClick = (menu: MenuItem) => {
    ReactGA.event({
      category: "Sidebar",
      action: "Menu Clicked",
      label: menu.name,
    });
    navigate(menu.link);
  };

  return (
    <section className="flex bg-slate-100 " style={{ fontFamily: 'Poppins' }} >
      <div
        className={`bg-white h-screen overflow-y-auto z-20 fixed transition-all duration-300 ${open ? "sm:w-64 w-56" : "sm:w-20 w-16"} sm:px-4 px-2`}
      >
        <div className="flex items-center justify-between py-4 select-none">
          <h1
            className={`text-lg font-bold text-blue-600 ${!open && "hidden"
              } `}
          >
            <img src={logo} alt="Logo" />
          </h1>
          <img
            src={window.innerWidth >= 768 ? Menu : logo}

            className={`cursor-pointer text-blue-600 ${window.innerWidth >= 768 ? "w-8 h-8" : "w-12 h-12"}  `}
            onClick={() => window.innerWidth >= 768 ? setOpen(!open) : null}
          />
        </div>

        <div className={`${roleId === 1 ? "mt-0" : "mt-6"} flex flex-col gap-3`}>
          {menus.map((menu, i) => {
            // 🔥 Modern Admin Separator UI
            if (menu.link === "#admin-separator") {
              return (
                <div key={i} className="mt-4 mb-2 px-3">
                  {open && (
                    <div className="flex items-center gap-3">
                      {/* Left line */}
                      <div className="flex-1 h-[1px] bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>

                      {/* Label */}
                      <span className="text-[11px] font-semibold text-gray-400 uppercase tracking-widest">
                        Admin
                      </span>

                      {/* Right line */}
                      <div className="flex-1 h-[1px] bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
                    </div>
                  )}
                </div>
              );
            }

            return (
              <Link
                to={menu.link}
                key={i}
                onClick={() => handleMenuClick(menu)}
                className={`group flex items-center gap-4 px-4 py-2.5 rounded-lg transition-all duration-200 ${activeMenu === menu.link
                    ? "bg-blue-600 text-white shadow-sm"
                    : "text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                  }`}
              >
                <div className="flex items-center justify-center w-6 h-6 flex-shrink-0">
                  <img
                    src={menu.icon}
                    alt={`${menu.name} Icon`}
                    className={`w-full h-full object-contain transition-all duration-200 ${activeMenu === menu.link
                        ? "brightness-0 invert"
                        : "opacity-70 group-hover:opacity-100"
                      }`}
                  />
                </div>

                <h2 className={`text-sm font-medium ${!open && "hidden"}`}>
                  {menu.name}
                </h2>
              </Link>
            );
          })}
        </div>
      </div>

      <div className={`flex-1 p-0 transition-margin duration-300 ${open ? "ml-64" : "sm:ml-20 ml-16"}`}>
        <Outlet />
      </div>
    </section>
  );
};

export default SidebarLayout;
